/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Items_Title1Inputs */

const id_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ms_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const da_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const de_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const en_us2_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const es_es2_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const es_mx2_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const fil_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Item`)
};

const fr_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const it_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articoli`)
};

const hu_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemek`)
};

const nl_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const no_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementer`)
};

const pl_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementy`)
};

const pt_br2_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const pt_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const ro_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemente`)
};

const fi_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohteet`)
};

const sv_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt`)
};

const vi_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục`)
};

const tr_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğeler`)
};

const cs_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položky`)
};

const bg_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обекти`)
};

const ru_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объекты`)
};

const uk_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елементи`)
};

const ar_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العناصر`)
};

const hi_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम`)
};

const th_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการ`)
};

const ja_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム`)
};

const zh_cn2_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const zh_hant1_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const ko_offerdetail_items_title1 = /** @type {(inputs: Offerdetail_Items_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템`)
};

/**
* | output |
* | --- |
* | "Items" |
*
* @param {Offerdetail_Items_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_items_title1 = /** @type {((inputs?: Offerdetail_Items_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Items_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_items_title1(inputs)
	if (locale === "ms") return ms_offerdetail_items_title1(inputs)
	if (locale === "da") return da_offerdetail_items_title1(inputs)
	if (locale === "de") return de_offerdetail_items_title1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_items_title1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_items_title1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_items_title1(inputs)
	if (locale === "fil") return fil_offerdetail_items_title1(inputs)
	if (locale === "fr") return fr_offerdetail_items_title1(inputs)
	if (locale === "it") return it_offerdetail_items_title1(inputs)
	if (locale === "hu") return hu_offerdetail_items_title1(inputs)
	if (locale === "nl") return nl_offerdetail_items_title1(inputs)
	if (locale === "no") return no_offerdetail_items_title1(inputs)
	if (locale === "pl") return pl_offerdetail_items_title1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_items_title1(inputs)
	if (locale === "pt") return pt_offerdetail_items_title1(inputs)
	if (locale === "ro") return ro_offerdetail_items_title1(inputs)
	if (locale === "fi") return fi_offerdetail_items_title1(inputs)
	if (locale === "sv") return sv_offerdetail_items_title1(inputs)
	if (locale === "vi") return vi_offerdetail_items_title1(inputs)
	if (locale === "tr") return tr_offerdetail_items_title1(inputs)
	if (locale === "cs") return cs_offerdetail_items_title1(inputs)
	if (locale === "bg") return bg_offerdetail_items_title1(inputs)
	if (locale === "ru") return ru_offerdetail_items_title1(inputs)
	if (locale === "uk") return uk_offerdetail_items_title1(inputs)
	if (locale === "ar") return ar_offerdetail_items_title1(inputs)
	if (locale === "hi") return hi_offerdetail_items_title1(inputs)
	if (locale === "th") return th_offerdetail_items_title1(inputs)
	if (locale === "ja") return ja_offerdetail_items_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_items_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_items_title1(inputs)
	return ko_offerdetail_items_title1(inputs)
});
export { offerdetail_items_title1 as "offerDetail.items.title" }